import { createContext, useContext } from 'react';

type PublicContextType = {
  isPublic: boolean;
};

export const PublicContext = createContext<PublicContextType>({
  isPublic: false,
});

// Public Provider는 route기준으로 share 하위 route에서만 isPublic을 true로 설정됨
export const PublicProvider = ({
  children,
  isPublic,
}: {
  children: React.ReactNode;
  isPublic: boolean;
}) => {
  return (
    <PublicContext.Provider value={{ isPublic }}>
      {children}
    </PublicContext.Provider>
  );
};

export const usePublic = () => {
  const { isPublic } = useContext(PublicContext);
  return isPublic;
};
